import state from "./guest-fill-out-state";
import mutations from "./guest-fill-out-mutations";
import actions from "./guest-fill-out-actions";
import getters from "./guest-fill-out-getters";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;